module.exports = __webpack_public_path__ + "static/media/calc-logo-small.08959cec.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/calc-logo-small.svg
// module id = 2651
// module chunks = 0